(function () {
  var root = document.getElementById('hb-menu');
  var toggle = document.getElementById('hb-menu-toggle');
  if (!root || !toggle) return;

  // `root` (#hb-menu) is intentionally `height: 0` (it floats over content
  // without pushing it down), so its own offsetHeight is always 0 — measure
  // the actual visible pill box instead for anything that needs a real height.
  var pill = root.querySelector('.hb-menu__pill') || root;

  function isOpen() {
    return root.classList.contains('hb-menu--open');
  }

  // `position: fixed` with a static top would either sit on top of the ticker
  // (on load) or leave a big gap once the ticker has scrolled away. We keep a
  // constant gap *below* the ticker's current on-screen position, which
  // shrinks toward that same gap as a floor once the ticker scrolls out of
  // view — so the sticky/scrolled gap ends up matching the resting gap below
  // the ticker instead of an arbitrary bigger number.
  var ticker = document.getElementById('hb-ticker');
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function updateMenuPosition() {
    var tickerHeight = ticker ? ticker.offsetHeight : 0;
    var gap = mobileQuery.matches ? 8 : 28;
    var top = Math.max(gap, tickerHeight + gap - window.scrollY);
    root.style.top = top + 'px';
    document.documentElement.style.setProperty('--hb-header-h', pill.offsetHeight + 'px');
  }

  updateMenuPosition();
  root.classList.add('hb-menu--ready');
  window.addEventListener('scroll', updateMenuPosition, { passive: true });
  window.addEventListener('resize', updateMenuPosition);

  function getFocusable() {
    return root.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  function open() {
    root.classList.add('hb-menu--open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', ((window.hbStrings || {}).closeMenu || 'Sulje valikko'));
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // CSS transition-delay proved unreliable for sequencing this close (both
  // for the pill's fit-content width and for coordinating it with the
  // panel's own fade/collapse) — values that looked right in isolation
  // didn't fire when expected in practice. Driving every stage from JS
  // with its own setTimeout removes that guesswork entirely: each phase
  // only starts once the previous one has actually been given time to
  // finish, confirmed by the timer itself rather than a declared CSS delay.
  var panel = root.querySelector('.hb-menu__panel');
  var OPACITY_MS = 110;
  var COLLAPSE_MS = 150;
  var closeTimers = [];

  function clearCloseTimers() {
    closeTimers.forEach(function (id) { clearTimeout(id); });
    closeTimers = [];
  }

  function close() {
    clearCloseTimers();

    // Pin the pill at its true open width so it can't narrow while the panel
    // text is still visible. On mobile the open pill isn't naturally sized —
    // it's deliberately stretched to `width: 61%` (wider than its content
    // needs, for a bigger touch target) — so resetting to `width: auto` and
    // measuring, as this used to do, discarded that stretch and captured the
    // much narrower fit-content size instead (just enough to wrap the bar's
    // icons). That wrong, too-small value then got pinned immediately, so
    // the pill visibly snapped narrow — clipping the still-fading nav text
    // against its right edge — the instant close() ran, before any fade had
    // even started. Clearing the transition (without touching `width`) also
    // settles a mid-flight open animation, but it does so by letting the
    // browser jump straight to the CSS class's already-declared target width
    // (61% on mobile, fit-content on desktop) instead of recomputing a
    // different, smaller "natural" size from scratch.
    pill.style.transition = 'none';
    var naturalWidth = pill.getBoundingClientRect().width;
    pill.style.width = naturalWidth + 'px';

    // Freeze the panel at its current open box size — width AND height —
    // then fade only its opacity. The panel's own `width` has the exact
    // same unreliable-CSS-transition-delay problem the pill's width had
    // (width: auto -> 0, delayed 340ms in the stylesheet): left alone it
    // was very likely snapping narrow almost immediately, clipping every
    // nav label, while opacity was still barely starting to fade — the
    // actual cause of the visible clipped-text flash.
    if (panel) {
      panel.style.transition = 'none';
      panel.style.width = 'auto';
      var panelWidth = panel.getBoundingClientRect().width;
      var panelHeight = panel.getBoundingClientRect().height;
      // Padding wasn't pinned here before — the moment the open class comes
      // off, its computed padding falls straight back to the closed rule's
      // padding with no transition covering it (only opacity is animated
      // in this phase), so the text visibly jumped position before fading.
      var panelPadding = getComputedStyle(panel).padding;
      panel.style.width = panelWidth + 'px';
      panel.style.maxHeight = panelHeight + 'px';
      panel.style.padding = panelPadding;
      void panel.offsetHeight; // commit the frozen size before animating opacity
      panel.style.transition = 'opacity ' + OPACITY_MS + 'ms ease-out';
      panel.style.opacity = '0';
    }
    void pill.offsetWidth; // commit the pinned width before the class change

    root.classList.remove('hb-menu--open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', ((window.hbStrings || {}).menu || 'Valikko'));
    document.removeEventListener('keydown', onKeydown);
    window.removeEventListener('scroll', onScroll);

    // Only once the text has actually had time to fully fade (confirmed by
    // this timer, not a CSS delay) does the now-invisible box collapse.
    closeTimers.push(setTimeout(function () {
      if (panel) {
        panel.style.transition = 'max-height ' + COLLAPSE_MS + 'ms ease-out, width ' + COLLAPSE_MS + 'ms ease-out, padding ' + COLLAPSE_MS + 'ms ease-out';
        panel.style.maxHeight = '0px';
        panel.style.width = '0px';
        panel.style.padding = '0 20px';
      }
    }, OPACITY_MS));

    // Once the collapse itself has had time to finish, release every
    // inline override so plain CSS governs the resting closed state again.
    closeTimers.push(setTimeout(function () {
      pill.style.transition = '';
      pill.style.width = '';
      if (panel) {
        panel.style.transition = '';
        panel.style.opacity = '';
        panel.style.maxHeight = '';
        panel.style.width = '';
        panel.style.padding = '';
      }
    }, OPACITY_MS + COLLAPSE_MS));
  }

  function onScroll() {
    close();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close();
      toggle.focus();
      return;
    }
    if (e.key === 'Tab') {
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  toggle.addEventListener('click', function () {
    if (isOpen()) {
      close();
    } else {
      open();
      refreshCartUI();
    }
  });

  root.querySelectorAll('.hb-menu__nav a').forEach(function (link) {
    link.addEventListener('click', close);
  });

  // --- Glass variant while floating over a full-bleed hero image ---
  // Any page can opt in by adding a [data-hb-hero-glass] element (e.g. the
  // mobile hero). The pill stays glass while that element's bottom edge is
  // still on screen, then switches to the plain dark pill once scrolled past.
  var glassTarget = document.querySelector('[data-hb-hero-glass]');
  if (glassTarget && 'IntersectionObserver' in window) {
    var glassObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          root.classList.toggle('hb-menu--glass', entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -100% 0px' }
    );
    glassObserver.observe(glassTarget);
  }

  // --- Live cart totals ---
  var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat.replace(/\{\{\s*amount\w*\s*\}\}/, amount);
  }

  function refreshCartUI() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var label = document.getElementById('hb-menu-cart-label');
        var badge = document.getElementById('hb-menu-cart-badge');
        var count = document.getElementById('hb-menu-cart-count');
        var total = document.getElementById('hb-menu-cart-total');
        var formatted = formatMoney(cart.total_price);

        if (label) label.textContent = cart.item_count + ' · ' + formatted;
        if (badge) badge.textContent = cart.item_count;
        if (total) total.textContent = formatted;
        if (count) count.textContent = ((window.hbStrings || {}).cartCaps || 'OSTOSKORI') + ' · ' + cart.item_count;
      })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', refreshCartUI);
  document.addEventListener('cart:refresh', refreshCartUI);
})();
